import { memo } from "react";
import { useLocalization } from "@fluent/react";
import cc from "classcat";

import SortableItem from "../../../../src/components/dragAndDrop/SortableItem";
import styles from "./DashboardCustomization.module.scss";
import SECTION_LABELS_TO_FLUENT_IDS from "../constants";

type SectionRowProps = {
  id: string;
};

const DashboardSectionRow = ({ id }: SectionRowProps) => {
  const { l10n } = useLocalization();
  const ftlId = SECTION_LABELS_TO_FLUENT_IDS[id];
  const label = ftlId ? l10n.getString(ftlId, null) : id;

  return (
    <SortableItem id={id}>
      {({ setNodeRef, attributes, listeners, style, isDragging }) => (
        <div
          ref={setNodeRef}
          style={style}
          className={cc([styles.row, isDragging && styles["row-dragging"]])}
          {...attributes}
          {...listeners}
        >
          {label}
          <span className={cc(["narmi-icon-menu", styles["icon-color"]])} />
        </div>
      )}
    </SortableItem>
  );
};

export default memo(DashboardSectionRow);
